var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveSessions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.875C8.01562 4.875 4.875 8.0625 4.875 12C4.875 15.9844 8.0625 19.125 12 19.125C15.9375 19.125 19.125 15.9375 19.125 12C19.125 8.0625 15.9375 4.875 12 4.875ZM12 16.875C9.28125 16.875 7.125 14.7188 7.125 12C7.125 9.32812 9.28125 7.125 12 7.125C14.6719 7.125 16.875 9.32812 16.875 12C16.875 14.7188 14.6719 16.875 12 16.875ZM12 0.375C5.57812 0.375 0.375 5.625 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.375 23.625 23.625 18.4219 23.625 12C23.625 5.625 18.375 0.375 12 0.375ZM12 21.375C6.79688 21.375 2.625 17.2031 2.625 12C2.625 6.84375 6.79688 2.625 12 2.625C17.1562 2.625 21.375 6.84375 21.375 12C21.375 17.2031 17.1562 21.375 12 21.375ZM12 9.375C10.5469 9.375 9.375 10.5938 9.375 12C9.375 13.4531 10.5469 14.625 12 14.625C13.4062 14.625 14.625 13.4531 14.625 12C14.625 10.5938 13.4062 9.375 12 9.375Z",
    fill: "#93A2BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSessions);
export default __webpack_public_path__ + "static/media/live-sessions.f70429f4.svg";
export { ForwardRef as ReactComponent };